import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "evrideo-x-button",
  templateUrl: "./x-button.component.html",
  styleUrls: ["./x-button.component.scss"],
})
export class XButtonComponent implements OnInit {
  @Input()
  overrideStyle = {};

  @Input()
  transitionEffect = "scale";

  styleObject: any = {
    width: "20px",
    height: "20px",
    cursor: "pointer",
  };

  constructor() {}

  ngOnInit() {
    this.styleObject = { ...this.styleObject, ...this.overrideStyle };
  }
}
